module.exports = __webpack_public_path__ + "img/1-02.22111a1b.png";